import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';
import { formatMoneyWithSign } from 'utils/currencyHelper';

const amountSuffix = '$40 per Connection';

export default new Presenter(
  {
    id: PropTypes.number,
    name: PropTypes.string,
    amount: PropTypes.string,
    isFree: PropTypes.bool,
  },
  {
    isPaidSubscription(subscription) {
      return !this.isFree(subscription);
    },
    subscriptionAmountLabel(subscription) {
      return this.isFree(subscription) ? this.readableAmount(subscription) : this.amountWithDecoration(subscription);
    },
    readableAmount(subscription) {
      return formatMoneyWithSign(this.amount(subscription), 'USD');
    },
    amountWithDecoration() {
      return `${amountSuffix}`;
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/SubscriptionPresenter.js